/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import T from 'i18n-react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { InputAdornment, IconButton, Input, InputLabel, FormControl } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import checkCircle from 'assets/img/check_circle.png';
import errorCircle from 'assets/img/error_circle.png';

const CustomTextField = (props) => {
  const [showPassword, setShowPassword] = useState(false);

  const {
    accessPath,
    disabled,
    name,
    noLabel,
    shrink,
    storeName,
    variant,
    setFieldTouched,
    onChange,
    usingShowPassword,
    visibilityIcons = { on: <Visibility />, off: <VisibilityOff /> },
    error,
    hideCheckIcon,
    ...rest
  } = props;

  const finalProps = Object.assign(
    {
      name,
      disabled,
      label: !noLabel ? T.translate(`${storeName}.${name}`) : '',
      variant,
      error,
      ...rest,
    },
    shrink ? { InputLabelProps: { shrink } } : {}
  );

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return usingShowPassword ? (
    <FormControl style={{ width: '100%' }}>
      <InputLabel>{finalProps.label}</InputLabel>
      <Input
        {...finalProps}
        onChange={(e) => {
          if (onChange) {
            onChange(e);
          }
          if (setFieldTouched) {
            setFieldTouched(name, false);
          }
        }}
        type={showPassword ? 'text' : 'password'}
        endAdornment={
          <InputAdornment position='end'>
            <IconButton
              aria-label='toggle password visibility'
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}>
              {showPassword ? visibilityIcons.on : visibilityIcons.off}
            </IconButton>
            {!hideCheckIcon && <img src={error ? errorCircle : checkCircle} alt='checkIcon' />}
          </InputAdornment>
        }
      />
    </FormControl>
  ) : (
    <TextField
      {...finalProps}
      onChange={(e) => {
        if (onChange) {
          onChange(e);
        }
        if (setFieldTouched) {
          setFieldTouched(name, false);
        }
      }}
    />
  );
};

CustomTextField.defaultProps = {
  accessPath: [],
  disabled: false,
  margin: 'dense',
  name: '',
  noLabel: false,
  storeName: '',
  type: 'text',
  value: '',
  onChange: () => {},
};

CustomTextField.propTypes = {
  type: PropTypes.string,
  storeName: PropTypes.string,
  accessPath: PropTypes.array,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  noLabel: PropTypes.bool,
  margin: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.arrayOf,
  ]),
  shrink: PropTypes.bool,
  onChange: PropTypes.func,
};

export default CustomTextField;
